import React from 'react';

const Select = (props) => {
    const {
        name        = '',
        value       = '',
        onChange    = (value) => {},
        disabled    = false,
        options     = [{
            value:  '',
            label:  ''
        }]
    } = props;

    const processOptions = () => {
        let components = [];

        if (!value || value === '') {
            components.push(
                <option value="" key="placeholder"></option>
            );
        }

        for (let i = 0; i < options.length; i++) {
            components.push(
                <option key={options[i].value} value={options[i].value}>{options[i].label}</option>
            );
        }

        return components;
    }

    return (
        <select
            value={value}
            onChange={(event) => onChange(event.target.value)}
            disabled={disabled}
            name={name}
            id={name}
            className={'input-field'}
            autoComplete="off"
        >
            {processOptions()}
        </select>
    );
}

export default Select;
